import React from 'react'
import Footer from './Footer';
import Header from './Header';
import Servicedata from './Api/service';

function Contact() {



    return (
        <>

           <Header/>

            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <h1 className="text-white">Contact.....!</h1>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-light rounded-pill"
                            >
                                CONTACT
                            </button>
                        </div>
                        <h1 style={{ textAlign: 'center' }}>
                            <span>Need Help?</span> <span className="link-primary">CONTACT</span>
                        </h1>
                    </div>
                </div>
            </section>
            <section id="contact" className="contact section">

                <div className="container" data-aos="fade-up" data-aos-delay={100}>
                    <div className="row">


                        <div className="col-md-5">
                            <div className="card border-primary border">
                                <div className="card-body">
                                    <h5 className="card-title text-primary">Address</h5>
                                    <p className="card-text">First Floor Maruti Darshan Complex, Near Prakash Motors Hero Showroom, Ganesh Chokdi, Anand, Gujarat - 388001</p>
                                </div> {/* end card-body*/}
                            </div> {/* end card*/}
                        </div> {/* end col*/}

                        <div className="col-lg-3">
                            <div className="card border-primary border">

                                <div className="card-body">
                                    <h5 className="card-title text-primary">Call Us</h5>
                                    <p className="card-text"><a href="tel:+917016407141" style={{ color: 'black' }}>+91 70164 07141  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a></p>

                                </div> {/* end card-body*/}
                            </div> {/* end card*/}
                        </div> {/* end col*/}

                        <div className="col-md-4">
                            <div className="card border-primary border">
                                <div className="card-body">
                                    <h5 className="card-title text-primary">Email Us</h5>
                                    <p className="card-text"><a href="mailto:neelsoni@mysfs24.com" style={{ color: 'black' }}>neelsoni@mysfs24.com  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a></p>
                                </div> {/* end card-body*/}
                            </div> {/* end card*/}
                        </div> {/* end col*/}
                    </div>
                </div>
            </section>{/* /Contact Section */}
            <section className="py-5">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-light rounded-pill"
                            >
                                Enquiry
                            </button>
                        </div>
                        <h1 style={{ textAlign: 'center' }}>
                            <span>Enquiry </span> <span className="link-primary">Form</span>
                        </h1>
                    </div>
                </div>
            </section>
            <section id="contact" className="contact section light-background">
                <div className="container" data-aos="fade-up" data-aos-delay={100}>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">

                                            <div className="tab-content">
                                                <div className="tab-pane show active">
                                                    <Servicedata/>
                                                </div> {/* end preview*/}
                                            </div> {/* end tab-content*/}
                                        </div> {/* end card-body */}
                                    </div> {/* end card*/}
                                </div> {/* end col */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <div className="col-lg-12">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d230.3013390768476!2d72.97496288122306!3d22.54836122978082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1725516052661!5m2!1sen!2sin" frameBorder={0} style={{ border: 0, width: '100%', height: 370 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
            <br />
            <Footer />

        </>
    )
}

export default Contact
